import { NgModule } from '@angular/core';
import { of } from 'rxjs';

import { Mxa710LookupTableLoaderService, Mxa7xxLookupTableService } from '../lib/mxa7xx-lookup-services';
import { Mxa7xxLookupTableData } from '../lib/mxa7xx-lookup-services/mxa7xx-lookup-table-loader.api';

@NgModule({
	providers: [
		{
			provide: Mxa710LookupTableLoaderService,
			useValue: {
				lookupMap$: of(new Map()),
				valueLimits$: of({
					limitsAngle: { minAngle: 0, maxAngle: 0 },
					limitsHeight: { minHeight: 0, maxHeight: 0 }
				}),
				load: () => Promise.resolve(true)
			} as Partial<Mxa710LookupTableLoaderService>
		},
		{
			provide: Mxa7xxLookupTableService,
			useValue: {
				lookupMxa710Values: (): Mxa7xxLookupTableData => ({ angle: 0, cx: 0, cy: 0, rx: 0, ry: 0 })
			} as Partial<Mxa7xxLookupTableService>
		}
	]
})
export class Mxa710LookupTestingModule {}
